import { LoadingButton } from '@mui/lab';
import { buttonClasses } from '@mui/material/Button';
import { styled } from '@mui/material';
import {
  primaryButtonBaseStyles,
  primaryButtonHoverStyles,
  primaryButtonPseudoElementStyles
} from 'common/theme/button/sharedButtonStyles';

const StyledAppbarPrimaryLoadingButton = styled(LoadingButton)(({ theme }) => ({
  ...primaryButtonBaseStyles(theme),
  padding: '6px 16px',
  '&::before': {
    ...primaryButtonHoverStyles,
    ...primaryButtonPseudoElementStyles(theme)
  },
  '&:hover::before': {
    opacity: 1
  },
  [`&.${buttonClasses.disabled}`]: {
    background: theme.palette.grey[800]
  }
}));

export default StyledAppbarPrimaryLoadingButton;
